<template>
  <div class="content my-0 py-1">
    <div class="container-fluid">
      <div class="row">
          <div class="col-12  mt-2 py-0">
              <h4 class="m-0 p-0 text-secondary d-inline">Data Vendor</h4>
              <button class="float-right btn btn-primary shadow mt-2" v-on:click="formNewvendor=!formNewvendor">Tambah Vendor Baru</button>
          </div>
          <transition name="fade">
            <div class="col-12  my-2 py-0" v-if="formNewvendor">
                <div class="row p-3 mx-2 bg-white shadow">
                    <div class="col-12 mb-3">
                        <h4 class="my-0 py-0">Form Vendor Varu</h4>
                        <hr>
                    </div>
                    <div class="col-12 col-md-6 col-lg-4 mt-2">
                        <label class="d-block">Nama Vendor <span style="color:red;">*</span></label>
                        <input type="text"  class="form-control w-100 rounded" v-model="newvendor.vendorName" />
                    </div>
                    <div class="col-12 col-md-6 col-lg-4 mt-2">
                        <label class="d-block">Telepon <span style="color:red;">*</span></label>
                        <input type="number"  class="form-control w-100 rounded" v-model="newvendor.telp" />
                    </div>
                    <div class="col-12 col-md-6 col-lg-4 mt-2">
                        <label class="d-block">Email <span style="color:red;">*</span></label>
                        <input type="text"  class="form-control w-100 rounded" v-model="newvendor.email" />
                    </div>
                    <div class="col-12 col-md-6 col-lg-4 mt-2">
                        <label class="d-block">Alamat <span style="color:red;">*</span></label>
                        <textarea type="text"  class="form-control w-100 rounded" v-model="newvendor.address" />
                    </div>
                    <div class="col-12 mt-3">
                        <div class="w-100 align-items-center justify-content-start" v-if="newvendorSaved">
                            <div class="alert alert-success" role="alert">
                                Berhasil menyimpan vendor baru.
                            </div>
                        </div>
                    </div>
                    <div class="col-12 mt-3">
                        <div class="w-100 align-items-center justify-content-start" v-if="errorNewvendor">
                            <div class="alert alert-danger" role="alert">
                                <div class="my-0">
                                    <p  class="d-block mt-1">Gagal menyimpan vendor baru.</p>
                                </div>
                                <div v-for="err in errorNewvendorList" v-bind:key="err" class="my-0">
                                    <p  v-for="note in err" v-bind:key="note" class="d-block mt-1">{{note}}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 mt-3">
                        <div class="d-flex align-items-center justify-content-start" v-if="savingNewvendor">
                            <div class="spinner-border" role="status" aria-hidden="true"></div>
                            <strong class=" ml-2">Menyimpan data, tunggu sebentar.</strong>
                        </div>
                        <button class="btn btn-primary float-right" type="button" v-on:click="saveNewvendor">Submit</button>
                    </div>
                </div>
            </div>
            </transition>
          <div class="col-12  my-2 py-0">
            <datatable :datas="Mastervendors" :structure="MastervendorTableStructure" :init="datatable.loadData" @searching="(val)=>!val.status?getMastervendors():Mastervendors=val.data" use-seeker seeker-url="/api/master/seeker/vendor">
                <template #customcell={obj,index}>
                    <td v-if="isMobile" class="py-3">
                        <ul style="list-style:none;width:100%;padding:0" class="rounded shadow bg-white p-2">
                            <li class="mt-2">
                                <div class="text-left mx-3 pt-0">
                                    <small class="my-0 py-0">Nama:</small>
                                    <br><b class="py-0 mx-0" style="font-size:10pt">{{ obj.vendor_name }}</b>
                                </div>
                                <hr class="my-1">
                            </li>
                            <li class="mt-2">
                                <div class="text-left mx-3 pt-0">
                                    <small class="my-0 py-0">Telepon:</small>
                                    <br><b class="py-0 mx-0" style="font-size:10pt">{{ obj.vendor_telphone }}</b>
                                </div>
                                
                            </li>
                            <li class="mt-2">
                                <div class="text-left mx-3 pt-0">
                                    <small class="my-0 py-0">Email:</small>
                                    <br><b class="py-0 mx-0" style="font-size:10pt">{{ obj.vendor_email }}</b>
                                </div>
                                
                            </li>
                            <li class="mt-2">
                                <div class="text-left mx-3 pt-0">
                                    <small class="my-0 py-0">Alamat:</small>
                                    <br><b class="py-0 mx-0" style="font-size:10pt">{{ obj.vendor_address }}</b>
                                </div>
                                <hr class="my-1">
                            </li>
                            <li class="mt-2">
                                <div class="text-left mx-3 pt-0">
                                    <b-button v-b-modal.modal-edit-vendor class="btn btn-info mr-2 mb-1" v-on:click="selectedvendor=index;dataEdit=Object.assign({},obj)"><b-icon icon="pencil-square"></b-icon></b-button>
                                    <button v-b-modal.modal-delete v-on:click="deleteId=obj.id;itemToDelete=obj" class="btn btn-danger mr-2 mb-1"><b-icon icon="trash"></b-icon></button>
                                    
                                </div>
                            </li>
                        </ul>
                    </td>
                    <td v-if="!isMobile">{{ index+ 1 }}</td>
                    <td v-if="!isMobile">{{ obj.vendor_name }}</td>
                    <td v-if="!isMobile">{{ obj.vendor_telphone }}</td>
                    <td v-if="!isMobile">{{ obj.vendor_email }}</td>
                    <td v-if="!isMobile">{{ obj.vendor_address }}</td>
                    <td v-if="!isMobile">
                        <b-button v-b-modal.modal-edit-vendor class="btn btn-info mr-2 mb-1" v-on:click="selectedvendor=index;dataEdit=Object.assign({},obj)"><b-icon icon="pencil-square"></b-icon></b-button>
                        <button v-b-modal.modal-delete v-on:click="deleteId=obj.id;itemToDelete=obj" class="btn btn-danger mr-2 mb-1"><b-icon icon="trash"></b-icon></button>
                    </td>
                </template>
            </datatable>
          </div>
      </div>
    </div>
    <!-- <b-modal no-close-on-esc  content-class="m-0"  id="modal-delete-vendor" title="Konfirmasi hapus vendor" scrollable no-close-on-backdrop @hide="deleteModalClose">
        <b-container fluid v-if="!datatable.loadData && Mastervendors.length>0">
            <b-row class="pt-1">
              <b-col cols="12" class="my-3">
                  <h4>Apakah yakin mau menghapus data dengan detail berikut:</h4>
                  <ul>
                      <li>vendor: {{Mastervendors[selectedToDelete].vendor_name}}</li>
                      <li>Telp: {{Mastervendors[selectedToDelete].vendor_telphone}}</li>
                  </ul>
              </b-col>
               <b-col cols="12" class="my-3 text-right"  v-if="deletevendorState">
                   <div class="d-flex align-items-center justify-content-start">
                        <div class="spinner-border" role="status" aria-hidden="true"></div>
                        <strong class=" ml-2">Menghapus data, tunggu sebentar.</strong>
                    </div>
                </b-col>
                <div class="col-12 mt-3"  v-if="vendorDeleted">
                    <div class="w-100 align-items-center justify-content-start">
                        <div class="alert alert-success" role="alert">
                            Berhasil menghapus data.
                        </div>
                    </div>
                </div>
                <div class="col-12 mt-3"  v-if="failDeletevendor">
                    <div class="w-100 align-items-center justify-content-start">
                        <div class="alert alert-danger" role="alert">
                            Gagal menghapus data klien.
                        </div>
                    </div>
                </div>
            </b-row>
        </b-container>
        <template #modal-footer>
            <div class="w-100 text-right m-0 p-0">
            <hr>
            <button class="btn btn-danger  mr-2" v-on:click="deletevendorData">Ya, hapus</button>
            <b-button class="btn btn-secondary" @click="(!deletevendorState)?$bvModal.hide('modal-delete-vendor'):''">Tutup</b-button>
            </div>
        </template>
    </b-modal> -->
    <b-modal no-close-on-esc  content-class="m-0"  id="modal-edit-vendor" title="Detail informasi vendor" scrollable no-close-on-backdrop size="lg" @hide="editModalClose">
        <b-container fluid v-if="!datatable.loadData && Mastervendors.length>0">
            <b-row class="pt-1">
                <div class="col-12 col-md-6 col-lg-4 mt-2">
                    <label class="d-block">Nama Vendor</label>
                    <input type="text"  class="form-control w-100 rounded" v-model="Mastervendors[selectedvendor].vendor_name" />
                </div>
                <div class="col-12 col-md-6 col-lg-4 mt-2">
                    <label class="d-block">Telepon</label>
                    <input type="number"  class="form-control w-100 rounded" v-model="Mastervendors[selectedvendor].vendor_telphone" />
                </div>
                <div class="col-12 col-md-6 col-lg-4 mt-2">
                    <label class="d-block">Email</label>
                    <input type="text"  class="form-control w-100 rounded" v-model="Mastervendors[selectedvendor].vendor_email" />
                </div>
                <div class="col-12 col-md-6 col-lg-4 mt-2">
                    <label class="d-block">Alamat</label>
                    <textarea type="text"  class="form-control w-100 rounded" v-model="Mastervendors[selectedvendor].vendor_address" />
                </div>
            
                <b-col cols="12" class="my-3 text-right"  v-if="editvendorState">
                   <div class="d-flex align-items-center justify-content-start">
                        <div class="spinner-border" role="status" aria-hidden="true"></div>
                        <strong class=" ml-2">Menyimpan data, tunggu sebentar.</strong>
                    </div>
                </b-col>
                <div class="col-12 mt-3"  v-if="updatevendorSaved">
                    <div class="w-100 align-items-center justify-content-start">
                        <div class="alert alert-success" role="alert">
                            Berhasil update data vendor.
                        </div>
                    </div>
                </div>
                <div class="col-12 mt-3"  v-if="errorvendorSaved">
                    <div class="w-100 align-items-center justify-content-start">
                        <div class="alert alert-danger" role="alert">
                            Gagal update data vendor.
                        </div>
                    </div>
                </div>
                <b-col cols="12" class="my-3 text-right">
                    <button class="btn btn-info" v-on:click="updatevendorData">Simpan</button>
                </b-col>
            </b-row>
        </b-container>
        <template #modal-footer>
            <div class="w-100 text-right m-0 p-0">
            <hr>
            <b-button class="btn btn-secondary mr-2" @click="(!editvendorState)?$bvModal.hide('modal-edit-vendor'):''">Tutup</b-button>
            <!-- <button class="btn btn-info" v-on:click="updateClientData">submit</button> -->
            </div>
        </template>
  </b-modal>

    <modal-delete url="/api/master/vendor/" @read="()=>{console.log('modal ready')}" @result="deleteResult" :targetid="deleteId">
    Yakin mau menghapus data dengan detail berikut :<br>
    <ul>
        <li>Nama: {{ itemToDelete.vendor_name }}</li>
        <li>Telepon: {{ itemToDelete.vendor_telphone }}</li>
        <li>Email: {{ itemToDelete.vendor_email }}</li>
        <li>Alamat: {{ itemToDelete.vendor_address }}</li>
    </ul>
    </modal-delete>

  </div>
</template>
<script>
//   import ChartCard from 'src/components/Cards/ChartCard.vue'
//   import StatsCard from 'src/components/Cards/StatsCard.vue'
//   import LTable from 'src/components/Table.vue'
    import * as axios from 'axios';
    import Datatable from '../../components/Datatable.vue';
    import SmartSelect from '../../components/SmartSelect.vue';
    import ModalDelete from '../../components/ModalDelete.vue';
    export default {
        components: {
        //   LTable,
        //   ChartCard,
        //   StatsCard
            'datatable':Datatable,
            'smart-select':SmartSelect,
            'modal-delete':ModalDelete
        },
        data () {
            return {
                 isMobile:false,

                //step 1 edit
                dataEdit:null,
                datatable:{
                    loadData:false
                },
                newvendor:{
                    vendorName:'',
                    telp:'',
                    email:'',
                    address:''
                },
                itemToDelete:{},
                deleteId:0,
                errorvendorSaved:false,
                updatevendorSaved:false,
                editvendorState:false,
                deletevendorState:false,
                failDeletevendor:false,
                vendorDeleted:false,
                Mastervendors:[],
                errorNewvendorList:[],
                formNewvendor:false,
                errorNewvendor:false,
                savingNewvendor:false,
                newvendorSaved:false,
                searchValue:'',
                selectedToDelete:0,
                selectedvendor:0,
                MastervendorTableStructure:[
                    {label:'No',key:null},
                    {label:'Nama Vendor',key:null},
                    {label:'Telepon',key:null},
                    {label:'Email',key:null},
                    {label:'Alamat',key:null},
                    {label:'Tindakan',key:null}
                ]
            }
        },
        created(){
            console.clear()
            this.$reActivateAccess(this) /*SETTIMEOUT LOGOUT OTOMATIS, (this,true) UTK MELIHAT DETIK DI BROWSHER*/
            console.log("vendor page")
            this.getMastervendors();
            this.isMobile = this.$isMobile
            window.addEventListener('resize', ()=>{
                console.log('screen update')
                this.isMobile = screen.width < 768
            });
        },
        methods:{
            deleteResult(deleted){
                console.log(deleted)
                if(deleted){
                    this.getMastervendors();
                }
            },
            getMastervendors(url=(this.$baseUrl+'/api/master/vendor')){
                this.datatable.loadData=true;
                axios.get(url,{'headers':{
                        'Authorization':'Bearer '+localStorage.getItem('accessToken')
                    }
                }).then((result)=>{
                    console.log(result)
                    this.datatable.loadData=false;
                    this.Mastervendors = result.data.data;
                }).catch((err)=>{
                    //check if token fail
                    if(err.response && err.response.status==401){
                        localStorage.removeItem('accessToken')
                    this.$router.push('/login')
                    }
                    console.log(err)
                    this.datatable.loadData=false;
                })
            },
            updatevendorItemType(value){
                this.Mastervendors[this.selectedvendor].item=value;
            },
            updateNewvendorItemType(value){
                this.newvendor.itemType=value;
            },
            saveNewvendor(){
                this.savingNewvendor=true
                this.errorNewvendor=false
                this.errorNewvendorList=[]
                if(this.newvendor.vendorName==''){
                    this.errorNewvendorList.push(["- Mohon isi nama"])
                }
                if(this.newvendor.telp==''){
                    this.errorNewvendorList.push(["- Mohon isi nomor telepon"])
                }
                if(this.newvendor.email==''){
                    this.errorNewvendorList.push(["- Mohon isi email"])
                }
                if(this.newvendor.address==''){
                    this.errorNewvendorList.push(["- Mohon isi alamat  "])
                }
                console.log(this.newUser)
                if(this.newvendor.vendorName!='' && this.newvendor.itemType!=''){
                    
                    axios.post(this.$baseUrl+'/api/master/vendor',
                    {
                        vendor_name:this.newvendor.vendorName,
                        vendor_telphone:this.newvendor.telp,
                        vendor_email:this.newvendor.email,
                        vendor_address:this.newvendor.address,
                    },
                    {
                        'headers':
                        {
                            'Authorization':'Bearer '+localStorage.getItem('accessToken')
                        }
                    }).then((result)=>{
                        //console.log(result)
                        if(result.data.create){
                            this.getMastervendors();
                        }
                        this.newvendor.vendorName='',
                        this.newvendor.telp='',
                        this.newvendor.email='',
                        this.newvendor.address='',
                        this.savingNewvendor=false
                        this.newvendorSaved=true

                        setTimeout(() => {
                            this.newvendorSaved=false
                            this.formNewvendor=false
                        }, 1500);

                    }).catch((err)=>{
                        //check if token fail
                        if(err.response && err.response.status==401){
                            localStorage.removeItem('accessToken')
                        this.$router.push('/login')
                        }
                        console.log(err.response)
                        this.errorNewvendorList=[]
                        this.errorNewUserList=Object.values(err.response.data.errors)
                        console.log(this.errorNewUserList)
                        this.errorNewvendor=true
                        this.savingNewvendor=false
                    })
                }else{
                    this.errorNewvendor=true
                    this.savingNewvendor=false
                }
            },
            deleteItem(idx){
                this.selectedToDelete=idx;
            },
            // deletevendorData(){
            //   console.log('deleting data')
            //   this.deletevendorState=true;
            //   axios.delete(this.$baseUrl+'/api/master/vendor/'+this.Mastervendors[this.selectedToDelete].id,{
            //       'headers':{
            //           'Authorization':'Bearer '+localStorage.getItem('accessToken')
            //       }
            //   }).then((result)=>{
            //     if(result.status==200){
            //         this.deletevendorState=false;
            //         this.vendorDeleted=true;
                    
            //       setTimeout(() => {
            //             this.Mastervendors.splice(this.selectedToDelete, 1);
            //             this.$bvModal.hide('modal-delete-vendor');
            //             this.vendorDeleted=false;
            //       }, 1500);
            //       console.log('yaya berhasil')
            //     }
            //   }).catch((err)=>{
          //check if token fail
            //   if(err.response && err.response.status==401){
            //     localStorage.removeItem('accessToken')
            //   this.$router.push('/login')
            //   }
            //     this.deletevendorState=false;
            //     this.failDeletevendor=true;
            //     setTimeout(() => {
            //           this.failDeletevendor=false;
            //       }, 1500);
            //     console.log(err)
            //   })
            // },
            deleteModalClose(mdl){
              if(this.deletevendorState){
                console.log('deleting')
                mdl.preventDefault()
              }else{
                console.log('closing')
                mdl.hide('modal-delete-user');
              }
            },
            editModalClose(mdl){
                //step 2 edit
                this.$set(this.Mastervendors,this.selectedvendor,this.dataEdit)
                //step 3 edit
                this.dataEdit = Object.assign({},null)
              if(this.editvendorState){
                console.log('deleting')
                mdl.preventDefault()
              }else{
                console.log('closing')
                mdl.hide('modal-delete-user');
              }
            },
            updatevendorData(){
                console.log('updating data')
              this.editvendorState=true;
              axios.put(this.$baseUrl+'/api/master/vendor/'+this.Mastervendors[this.selectedvendor].id,{
                vendor_name:this.Mastervendors[this.selectedvendor].vendor_name,
                vendor_telphone:this.Mastervendors[this.selectedvendor].vendor_telphone,
                vendor_email:this.Mastervendors[this.selectedvendor].vendor_email,
                vendor_address:this.Mastervendors[this.selectedvendor].vendor_address,
                //role:this.users[this.selectedClient].role,
              },{
                  'headers':{
                      'Authorization':'Bearer '+localStorage.getItem('accessToken')
                  }
              }).then((result)=>{
                if(result.status==200){
                  this.editvendorState=false;
                  this.updatevendorSaved=true;
                  //step 4 edit
                  this.dataEdit = this.Mastervendors[this.selectedvendor]
                  setTimeout(() => {
                      this.updatevendorSaved=false;
                      this.$bvModal.hide('modal-edit-vendor')
                  }, 1000);
                  console.log('yaya berhasil')
                }
              }).catch((err)=>{
                //check if token fail
                if(err.response && err.response.status==401){
                    localStorage.removeItem('accessToken')
                this.$router.push('/login')
                }
                this.editvendorState=false;
                this.errorvendorSaved=true;
                setTimeout(() => {
                      this.errorvendorSaved=false;
                  }, 1000);
                console.log(err)
              })
            }
            
        },
    }
</script>
<style scoped>
.btn {
    padding:2px 6px;
}
::v-deep .modal-content {
    margin: -3.25rem auto;
}

/* MENGHILANGKAN ICON NUMBER BAWAAN TYPE */
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}
</style>
